import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { WorldComponent } from './world/world.component';
import { LevelSelectComponent } from './level-select/level-select.component' ;
import { TaskSelectComponent } from './task-select/task-select.component' ;
import { SubtaskSelectComponent } from './subtask-select/subtask-select.component' ;
import { TaskSelectButtonComponent } from './task-select/task-select-button/task-select-button.component';
import { FormatStringPipe } from '../core/pipes/format-string.pipe';
import { SubtaskSelectButtonComponent } from './subtask-select/subtask-select-button/subtask-select-button.component';

@NgModule({
    declarations: [
        WorldComponent,
        LevelSelectComponent,
        TaskSelectComponent,
        SubtaskSelectComponent,
    ],
    imports: [
        SharedModule,
        CommonModule,
        TaskSelectButtonComponent,
        FormatStringPipe,
        SubtaskSelectButtonComponent,
    ],
})
export class WorldNavigationModule { }
